/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2022-2025 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, {useState} from 'react'
import {config} from 'corero-ssp-ui/src/core/app-config'
import sharedConfig from "../../core/sharedConfig";
import {useThemeConfig} from "../../stores/AppConfigStore";
import {Helmet} from "react-helmet";


/**
 * Handles setting the Helmet using title configuration
 * @returns {JSX.Element}
 * @constructor
 */
const GlobalHelmet = () => {
  const [themeConfig] = useThemeConfig();
  const [cacheBust] = useState(Date.now());
  const templateString = themeConfig.page_title_text ? `${themeConfig.page_title_text} - %s` : 'Loading...';
  return (<Helmet defer={false} titleTemplate={templateString} defaultTitle={'Loading...'}>
    <link rel="icon" type="image/png" sizes="16x16" href={`${sharedConfig.apis.theme + '/faviconImage'}/${config.faviconDimensions.D_16X16}?${cacheBust}`} />
    <link rel="icon" type="image/png" sizes="32x32" href={`${sharedConfig.apis.theme + '/faviconImage'}/${config.faviconDimensions.D_32X32}?${cacheBust}`} />
  </Helmet>)
}

export default GlobalHelmet
